<template>
  <div class="main fc ac">
    <img
      style="width: 260px;margin-top: 30px"
      src="@/assets/index/文字@2x.png"
      alt
    />
    <van-collapse
      class="mt20"
      :accordion="true"
      v-model="activeNames"
      style="width:100%"
    >
      <van-collapse-item
        title-class="red"
        label-class="black"
        class="active"
        title="概念"
        name="1"
      >
        <div class="sj">遗体（角膜）捐献，是指自然人生前采用书面或者订立遗嘱的形式自愿表示在去世后，由其执行人将遗体的全部或者部分捐献给医学科学事业的行为，以及生前未表示不同意捐献意愿的自然人死亡后，由其配偶、成年子女、父母以书面形式共同决定将遗体的全部或者部分捐献给医学科学事业的行为。</div>

        <div class="sj mt10">捐献的遗体（角膜）主要用于医学教学、医学科研、临床解剖和角膜移植。遗体（角膜）捐献应当遵循自愿、无偿的原则。</div>

        <div class="sj mt10">除了对医学事业的贡献外，遗体（角膜）捐献还对于中华民族移风易俗、推进殡葬改革、节约土地资源，体现捐献者崇尚科学的唯物主义生死观和传播“人道、博爱、奉献”的精神境界，促进精神文明和社会进步都有着深远的现实意义和历史意义。</div>
      </van-collapse-item>
      <van-collapse-item
        title-class="red"
        title="办理流程"
        name="2"
      >
        <div>
          <div class="sj mt10">居民自愿捐献遗体（角膜），由本人携带有效身份证明到就近的登记机构办理登记手续，如委托他人办理，则需携带委托书和双方有效身份证明。</div>
          <div class="sj mt10">上海市遗体（角膜）捐献申请、实现流程图</div>
         
          <div class="fr jc ac mt40">
            <img
              style="width:70vw"
              src="../../assets/corneal/捐献流程图.png"
              alt
            />
          </div>
        </div>
      </van-collapse-item>
      <van-collapse-item
        title-class="red"
        title="遗体（角膜）接受站"
        name="3"
      >
        <div>
          <div class="fr jc ac mt20">
            <img
              style="width:80vw;"
              src="../../assets/corneal/接受站.png"
              alt
            />
          </div>
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return { activeNames: "1" };
  },
  methods: {},
  components: {},
  mounted() {}
};
</script>


<style lang="less" scoped>
.main {
  box-sizing: border-box;
  // padding: 44px;
  width: 100vw;
  height: 100vh;

  background-image: url("./../../assets/index/bg.png");
  background-size: contain;
}
.active {
  background-color: #fb5358;
  color: white;
}
.black {
  color: black;
}
/deep/ .van-collapse-item__content {
  color: black;
}
/deep/ .van-collapse-item__content {
  background-color: #fffafa;
}
.red {
  font-weight: bold;
  color: #fb5363;
}
/deep/.van-cell__title {
  font-weight: bold;
}
</style>


